import { _, Marionette } from "../../vendor";
import Biscuit from "./Biscuit";

/**
 * @class Rbac (Role Based Access Control)
 * @author Felix Albroscheit
 *
 * Checks CRUD-permissions for the logged in user
 *
 * @param model : Backbone.Model with _rbac[]-attributes
 */
// @ts-ignore
export default Marionette.Object.extend({
  initialize(model: any): void {
    this._userRole = Biscuit.get("user.role");
    this.setRoleModel(model);
  },

  setRoleModel(roleModel: any): void {
    if (roleModel._rbac) {
      this._roleModel = roleModel._rbac;
    } else if (typeof roleModel !== "undefined" && typeof roleModel.prototype !== "undefined") {
      this._roleModel = roleModel.prototype._rbac;
    }
  },

  /**
   * @function hasPermission
   * @param action : ['add','read','write','delete']
   */
  hasPermission(action: any): boolean | undefined {
    if (typeof this._roleModel === "undefined") {
      return;
    }

    if (this._userRole !== "superadmin") {
      if (typeof this._roleModel[this._userRole] == "undefined") {
        console.log("Rbac.js - WARNING: No defined user list for role " + this._userRole);

        if (this._roleModel["user"][action]) {
          console.log("Rbac.js - ATTENTION: Falling back to default (users) role");
        }

        return false;
      } else {
        if (this._roleModel[this._userRole][action]) {
          return true;
        }

        return false;
      }
    }
  },
});
